import axios from "axios";
import React, { useState, useEffect, useContext, useRef } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import ErrorHandler from "../../../components/core/ErrorHandler";
import { LoadingSpinner } from "../../../components/layout/LoadingSpinner";
import Accordion from "../../../components/Accordion";
import ManualRemittanceForm from "./ManualRemittanceForm";
import ClaimEntry from "./ClaimEntry";
import { GetISODate } from "shared/helpers/DateHelpers";

import {
  DefaultColumnWidth,
  DefaultWideColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import {
  MoneyCell,
  AggregateMoneyFooterCell,
} from "../../../components/grid/Kendo/CustomKendoGridCells";
import { GetDataWithCleanedDates } from "shared/helpers/DateHelpers.js";
import { GridColumn } from "@progress/kendo-react-grid";
import { UserContext } from "shared/context/UserContext";
import SingleCheckExcelExportWrapper from "../../../components/export/SingleCheckExcelExportWrapper";
import SingleCheckPdfExportWrapper from "../../../components/export/SingleCheckPdfExportWrapper";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import useGridButtons from "shared/components/grids/hooks/useGridButtons";
import { useReactQueryHelpers } from "shared/hooks/useReactQueryHelpers";
import { useDeleteSelectedClaims } from "./hooks/useDeleteSelectedClaims";
import { useIncompleteManualRemittance } from "./hooks/useIncompleteManualRemittance";

import { OrganizationTypes } from "shared/constants/OrganizationTypes";
import DisabledItemNotification from "shared/components/notifications/DisabledItemNotification";

export default function ManualRemittance(props) {
  const { passedProps } = props;
  const user = passedProps.user.email;

  const { invalidateReactQueryKey } = useReactQueryHelpers();
  let { mutate: mutateForDeleteSelectedClaims } = useDeleteSelectedClaims();

  /*
  NOTE: I think what I want to do here is basically "set this value to true" once we're all ready to delete,
  and then update the callback to "Set this value back to false" upon completion OR an error
  */
  const [deleteClaimsIsReady, setDeleteClaimsIsReady] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  // const [expanded, setExpanded] = useState(false);
  const [submittedFormData, setSubmittedFormData] = useState(false);
  const [submittedClaimFormData, setSubmittedClaimFormData] = useState(false);
  const [generatedPmid, setGeneratedPmid] = useState(null);
  //NOTE TODO: I think the useStates here for clearPaymentMaster and clearClaimDetail can be done more cleanly just based on other values
  const [clearPaymentMaster, setClearPaymentMaster] = useState(false);
  const [clearClaimDetail, setClearClaimDetail] = useState(false);
  const [retrievedClaimDetail, setRetrievedClaimDetail] = useState("");
  const [entryOption, setEntryOption] = useState({
    includePatientName: false,
    includePaymenttype: false,
  });
  const [mainGridAggregates, setMainGridAggregates] = useState([]);
  const [showResetClaimsModal, setShowResetClaimsModal] = useState(false);
  const [showUnableLocateClaimsModal, setShowUnableLocateClaimsModal] =
    useState(false);
  const [
    createRemittanceConfirmationModal,
    setCreateRemittanceConfirmationModal,
  ] = useState(false);
  const [paymentExportModel, setPaymentExportModel] = useState(false);
  const [currentCheckData, setCurrentCheckData] = useState();
  const [querystringPmid, setQueryStringPmid] = useState();
  const [incompleteManualRemittanceId, setIncompleteManualRemittanceId] =
    useState(null);
  const { AddGridButton, gridButtons } = useGridButtons();
  const [clientGridApiParams, setClientGridApiParams] = useState();
  const [claimGridSelectedKeys, setClaimGridSelectedKeys] = useState(null);
  const [gridHasData, setGridHasData] = useState(false);

  const userConfig = useContext(UserContext);

  // Returns true if there is an active incomplete manual remittance
  function hasActiveManualRemittance() {
    return (
      incompleteManualRemittanceId !== null && incompleteManualRemittanceId > 0
    );
  }

  // Use the new React Query hook for fetching incomplete manual remittance
  // Defensive: check for null userConfig or userConfig.currentOrganization
  const safeUserEmail =
    userConfig && userConfig.email ? userConfig.email : null;
  const safeCurrentOrg =
    userConfig && userConfig.currentOrganization
      ? userConfig.currentOrganization
      : null;

  // Define key constant for consistent React Query cache invalidation
  const incompleteRemittanceDataItemKey =
    "ManualRemittanceIncompleteRemittanceDataItemKey";

  const claimsGridDataQueryKey = "ManualRemittanceClaimsGridDataQueryKey";

  const {
    data: incompleteManualRemittanceData,
    isLoading: isLoadingIncompleteRemittance,
  } = useIncompleteManualRemittance(
    safeUserEmail,
    safeCurrentOrg,
    incompleteRemittanceDataItemKey
  );

  const sendAggregatesToParent = (aggregatesFromSharedMainAgingGrid) => {
    setMainGridAggregates(aggregatesFromSharedMainAgingGrid.data);
  };

  const gridRef = useRef(null);

  const mainGridMoneyColumnAggregateSettings = [
    { aggregate: "sum", field: "adjustment" },
    { aggregate: "sum", field: "paidAmount" },
    { aggregate: "sum", field: "outStandingAmount" },
    { aggregate: "sum", field: "transactionFee" },
  ];

  function handleDeleteSelectedClaimRows() {
    const selectedKeys = gridRef.current.GetSelectedGridDataKeys();

    if (selectedKeys.length < 1) {
      alert("No rows selected.");
    }

    setClaimGridSelectedKeys(selectedKeys);
    setDeleteClaimsIsReady(true);
  }

  /*
  NOTE: This useEffect here is needed because although handleSelectedClaimRows() can set state,
  it seems to have issues retrieving state. You can see this by console.log() some state values used in the API call
  in the DeleteSelectedClaimsFromIncompleteManualRemittance() function.
  */
  // useEffect(() => {
  //   if (claimGridSelectedKeys) {
  //     DeleteSelectedClaimsFromIncompleteManualRemittance();
  //   }
  // }, [claimGridSelectedKeys]);

  //set the grid buttons
  useEffect(() => {
    AddGridButton("Delete Selected", handleDeleteSelectedClaimRows, true);
  }, []);

  // The getIncompleteManualRemittanceIfExists function has been replaced by the useIncompleteManualRemittance hook

  const RemittanceLookupActionCell = (props) => {
    async function EditClick(event) {
      // setEnableAddClaimEntryButton(true);
      // setPyidForEdit(props.dataItem.id);
      GetClaimData(props.dataItem.id);
    }

    return (
      <td className="noPadding" {...props.style}>
        <Row className="reducedHeight">
          <div className="col-sm-3">
            <Button variant="link" onClick={EditClick}>
              Edit
            </Button>
          </div>
        </Row>
      </td>
    );
  };

  //NOTE: I think this is only used in the instance where we're routed to this page when the user clicks on a manual remit from "Remittance Lookup" page
  useEffect(() => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let pmid = params.get("pmid");
    setQueryStringPmid(pmid);

    // We don't need to call getIncompleteManualRemittanceIfExists() anymore
    // as the useIncompleteManualRemittance hook handles this automatically
  }, []);

  useEffect(() => {
    if (querystringPmid != null) {
      getPMIDDetails(querystringPmid);
    }
  }, [querystringPmid]);

  // Handle data from the useIncompleteManualRemittance hook
  useEffect(() => {
    if (
      incompleteManualRemittanceData &&
      incompleteManualRemittanceData.mpmPmid &&
      !querystringPmid
    ) {
      setIncompleteManualRemittanceId(incompleteManualRemittanceData.mpmPmid);
      getPMIDDetails(incompleteManualRemittanceData.mpmPmid);
      setClientGridApiParams({
        user: user,
        pmid: incompleteManualRemittanceData.mpmPmid,
      });
  }
  }, [incompleteManualRemittanceData, querystringPmid]);

  // useEffect(() => {
  //   if (existingManualRemittancePmid != null) {
  //     getPMIDDetails(existingManualRemittancePmid);
  //   }
  // }, [existingManualRemittancePmid]);

  function getPMIDDetails(pmid) {
    setIsLoading(true);
    try {
      let accessToken = passedProps.auth.getAccessToken();

      axios
        .get(`api/ManualRemittance/GetManualRemittanceByPMID`, {
          params: {
            user: user,
            pMID: pmid,
          },
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then(function (response) {
          setIsLoading(false);
          setCurrentCheckData(response.data);
        })
        .catch(onFailure);
    } catch (exception) {}
  }

  useEffect(() => {
    if (generatedPmid) {
      setPaymentExportModel(true);
    }
  }, [generatedPmid]);

  function handleResetClaimsOkModal() {
    if (submittedFormData) {
      ResetCheckClaims(submittedFormData);
    }
    setShowResetClaimsModal(false);
  }

  async function downloadClick(type) {
    const accessToken = passedProps.auth.getAccessToken();

    if (type === "Excel") {
      await SingleCheckExcelExportWrapper(
        generatedPmid,
        accessToken,
        setIsLoading
      );
    } else if (type === "PDF") {
      await SingleCheckPdfExportWrapper(
        generatedPmid,
        accessToken,
        setIsLoading
      );
    }
  }

  function handleCreateRemittanceOkModal() {
    setCreateRemittanceConfirmationModal(false);
    GenerateManualRemittance(submittedFormData);
  }

  function handleCreateRemittanceCancelModal() {
    setCreateRemittanceConfirmationModal(false);
  }
  function handleResetClaimsCancelModal() {
    setShowResetClaimsModal(false);
  }

  function handleCreateManualClaim() {
    SaveNewManuallyEnteredClaim(submittedClaimFormData, "1");
    setShowUnableLocateClaimsModal(false);
  }
  function handleCancelCreateManualClaim() {
    setShowUnableLocateClaimsModal(false);
  }

  //NOTE: Basically we want the data to get refetched after a new claim is added
  function HandleClaimEntryFormSubmit(formInput) {
    /*
    NOTE: We really only need this setState because it's for the
    "this claim is not found, would you like to create it" confirmation modal
    */
    setSubmittedClaimFormData(formInput);

    //NOTE: This is for a new manual claim entry
    if (
      incompleteManualRemittanceId !== null &&
      incompleteManualRemittanceId > 0 &&
      formInput.id === 0
    ) {
      SaveNewManuallyEnteredClaim(formInput, "0");
    }
    //NOTE: And this is for editing an existing manual claim entry
    else if (
      incompleteManualRemittanceId !== null &&
      incompleteManualRemittanceId > 0 &&
      formInput.id > 0
    ) {
      UpdateExistingManuallyEnteredClaim(formInput, formInput.id, "0");
    }
  }

  //NOTE: This is what fires off when the "Create Check" button is clicked.
  function handleFormSubmit(formInput) {
    setSubmittedFormData(formInput);
    // setEnableAddClaimEntryButton(false);

    CreateOrUpdateCheck(formInput);
  }

  function onlyUpdateSubmittedFormDataFromChild(input) {
    setSubmittedFormData(input);
  }

  //NOTE: This is what fires off when the "Update Check" button is clicked
  function HandleUpdateCheckClick(formInput) {
    CreateOrUpdateCheck(formInput);
  }

  function handleEntryOptionsChange(formInput) {
    setEntryOption(formInput);
  }

  function handleResetCheck(formInput) {
    DeletePaymentMaster(formInput);
  }

  function handleResetClaimOnClick() {
    setShowResetClaimsModal(true);
  }
  function handleCreateRemittanceOnClick() {
    setCreateRemittanceConfirmationModal(true);
  }

  // const sendAccordionParent = (props) => {
  //   setExpanded(props);
  // };

  function GetClaimData(pyidForEdit) {
    if (pyidForEdit > 0 && incompleteManualRemittanceId > 0) {
      try {
        setIsLoading(true);
        let accessToken = passedProps.auth.getAccessToken();

        axios
          .get(`api/ManualRemittance/GetClaimById`, {
            params: {
              user: user,
              pyId: pyidForEdit,
              pMID: incompleteManualRemittanceId,
            },
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .then(function (response) {
            setIsLoading(false);
            setRetrievedClaimDetail(response.data.claimDetails);
            invalidateReactQueryKey(claimsGridDataQueryKey);
          })
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
      }
    }
  }

  // Defensive: check for nulls before accessing .type or .value
  function CreateOrUpdateCheck(formInput) {
    if (formInput) {
      setIsLoading(true);
      try {
        let accessToken = passedProps.auth.getAccessToken();
        const orgType =
          userConfig && userConfig.currentOrganization
            ? userConfig.currentOrganization.type
            : null;
        const orgValue =
          userConfig && userConfig.currentOrganization
            ? userConfig.currentOrganization.value
            : null;

        axios
          .post(
            "api/ManualRemittance/CreateOrUpdateIncompleteManualRemittance",
            {
              user: user,
              checkAmount: formInput.checkAmount,
              checkDate: formInput.checkDate,
              checkNumber: formInput.checkNumber,
              endDate: formInput.endDate,
              paymentDate: formInput.paymentDate,
              selectedLocations: formInput.selectedLocations,
              payerId: formInput.selectedPayers,
              startDate: formInput.startDate,
              includePatientName: formInput.includePatientName,
              includePaymenttype: formInput.includePaymenttype,
              includeDisabledWarning: formInput.disableClaimWarning,
              pMID: formInput.paymentId,
              shouldUpdateCheck: formInput.shouldUpdateCheck,
              shouldUpdateClaims: formInput.shouldUpdateClaims,
              gPID:
                (userConfig.contactType === "GCT" ||
                  userConfig.contactType === "UCT") &&
                  orgType === OrganizationTypes.Group
                  ? orgValue
                  : null,
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          )
          .then(function (response) {
            setIsLoading(false);
            if (response.data) {
              // setIncompleteManualRemittanceId(response.data);
              // setShowMessagePaymentMaster(false);
              setSubmittedFormData(formInput);
              if (formInput.paymentId == null) {
                setError({
                  status: 200,
                  Message: "New Check Information created.",
                });
              } else {
                setError({
                  status: 200,
                  Message: "Check Information updated.",
                });
              }

              setIncompleteManualRemittanceId(response.data);

              // invalidateReactQueryKey(
              //   "api/ManualRemittance/GetIncompleteManualRemittanceForUserEmail"
              // );
              // GetClaimsForIncompleteManualRemittance(response.data);

              invalidateReactQueryKey(incompleteRemittanceDataItemKey);
              invalidateReactQueryKey(claimsGridDataQueryKey);
            }
          })
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
      }
    }
  }

  // function GetClaimsForIncompleteManualRemittance(manualRemittancePmid) {
  //   setClientGridApiParams({
  //     user: user,
  //     pmid: manualRemittancePmid
  //   });
  // }

  function ResetCheckClaims(formInput) {
    setIsLoading(true);
    if (formInput) {
      try {
        let accessToken = passedProps.auth.getAccessToken();

        let params = {
          user: user,
          checkAmount: formInput.checkAmount,
          checkDate: GetISODate(formInput.checkDate),
          checkNumber: formInput.checkNumber,
          endDate: GetISODate(formInput.endDate),
          paymentDate: GetISODate(
            formInput.paymentDate ? formInput.paymentDate : null
          ),
          selectedLocations: formInput.selectedLocations,
          payerId: formInput.selectedPayers,
          startDate: GetISODate(formInput.startDate),
          includePatientName: formInput.includePatientName,
          includePaymenttype: formInput.includePaymenttype,
          includeDisabledWarning: formInput.disableClaimWarning,
          pMID: incompleteManualRemittanceId,
          shouldUpdateCheck: false,
          shouldUpdateClaims: true,
        };

        axios
          .post(
            "api/ManualRemittance/CreateOrUpdateIncompleteManualRemittance",
            params,
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          )
          .then(function (response) {
            setIsLoading(false);
            if (response.data) {
              setIncompleteManualRemittanceId(response.data);
              // GetClaimsForIncompleteManualRemittance(response.data);
              // invalidateReactQueryKey(
              //   "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
              // );

              invalidateReactQueryKey(incompleteRemittanceDataItemKey);
              invalidateReactQueryKey(claimsGridDataQueryKey);
              setError({ status: 200, Message: "Claim reset successfully." });
            }
          })
          .catch(onFailure);
      } catch (exception) {
        console.log(exception);
        onFailure(exception);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    if (clearPaymentMaster) {
      setClearPaymentMaster(false);
    }
  }, [clearPaymentMaster]);

  function clearAllFormsAndGrids() {
    setIncompleteManualRemittanceId(null);
    // setPyidForEdit(null);
    setClearClaimDetail(true);
    setClearPaymentMaster(true);
    setMainGridAggregates([]);
    // setEnableAddClaimEntryButton(false);
    setClientGridApiParams({
      user: user,
      pmid: null,
    });
    // invalidateReactQueryKey(
    //   "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
    // );
    invalidateReactQueryKey(incompleteRemittanceDataItemKey);
  }

  function GenerateManualRemittance(formInput) {
    if (formInput && userConfig.currentOrganization) {
      setIsLoading(true);
      try {
        let accessToken = passedProps.auth.getAccessToken();

        axios
          .post(
            `api/ManualRemittance/GeneratePaymentEntry`,
            {
              user: user,
              checkAmount: formInput.checkAmount,
              selectedLocations: formInput.selectedLocations,
              mMID: "0", // As per legacy code, we pass 0 for mMID
              pMID: incompleteManualRemittanceId,
              gPID:
                userConfig.contactType === "GCT" ||
                  userConfig.contactType === "UCT"
                  ? userConfig.currentOrganization.value
                  : null,
              total: getTotal("paidAmount"),
              adjustment: formInput.checkAmount - getTotal("paidAmount"),
              paidAmount: 0, // As per legacy code, we pass 0 for paidAmount
              pYID: 0, // As per legacy code, we pass 0 for pYID
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          )
          .then(function (response) {
            if (response.data && response.data.pmid) {
              setIsLoading(false);
              setGeneratedPmid(response.data.pmid);
              setError({
                status: 200,
                Message: "New payment generated successfully.",
              });
              invalidateReactQueryKey(incompleteRemittanceDataItemKey);
              invalidateReactQueryKey(claimsGridDataQueryKey);
              clearAllFormsAndGrids();
            } else {
              setError({ status: 500, Message: "Unable to generate payment." });
            }
          })
          .catch(function (error) {
            //NOTE: MPI-741 - a 503 here means the remit was saved, but its data isn't confirmed
            //readable yet (e.g. database write/read latency). This is different from a hard failure.
            if (error.response && error.response.status === 503) {
              setIsLoading(false);
              setError({
                status: 503,
                Message:
                  "The remittance was saved, but its data isn't available for viewing or PDF generation yet. Please wait a moment and try again.",
              });
              return;
            }

            onFailure(error);
          });
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
      }
    }
  }

  function SaveNewManuallyEnteredClaim(formInput, forceCreateManualClaim) {
    if (formInput) {
      setIsLoading(true);
      try {
        let accessToken = passedProps.auth.getAccessToken();

        let apiProps = {
          user: user,
          pmid: incompleteManualRemittanceId,
          mmids: submittedFormData.selectedLocations,
          pbid: submittedFormData.selectedPayers,
          ncpdp: formInput.selectedLocations,
          rxNum: formInput.script,
          serviceDate: formInput.dispDate,
          fee: formInput.fee,
          paidAmount: formInput.paidAmount,
          force: forceCreateManualClaim,
          firstName: formInput.firstName,
          middleName: formInput.middleName,
          lastName: formInput.lastName,
          paymentTypeId: formInput.paymentType,
          disableClaimWarn: submittedFormData.disableClaimWarning,
        };

        axios
          .post("api/ManualRemittance/InsertClaimEntry", apiProps, {
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .then(function (response) {
            setIsLoading(false);
            setClearClaimDetail(true);
            if (response.data) {
              setError({ status: 200, Message: "Claim records created." });
              // GetClaimsForIncompleteManualRemittance(incompleteManualRemittanceId);
              // setPyidForEdit(null);
              // invalidateReactQueryKey(
              //   "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
              // );

              invalidateReactQueryKey(incompleteRemittanceDataItemKey);
              invalidateReactQueryKey(claimsGridDataQueryKey);
            } else {
              //confirm popup
              //setForce("0");
              setShowUnableLocateClaimsModal(true);
            }
          })
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
      }
    }
    setClearClaimDetail(false);
  }

  function UpdateExistingManuallyEnteredClaim(formInput, pyidForEdit, force) {
    if (formInput) {
      setIsLoading(true);
      try {
        let accessToken = passedProps.auth.getAccessToken();

        axios
          .post(
            `api/ManualRemittance/UpdateClaimEntry`,
            {
              user: user,
              pMID: incompleteManualRemittanceId,
              pyid: pyidForEdit,
              pBID: submittedFormData.selectedPayers,
              nCPDP: formInput.selectedLocations,
              rXNUM: formInput.script,
              serviceDate: formInput.dispDate,
              fee: formInput.fee,
              paidAmount: formInput.paidAmount,
              force: force,
              firstName: formInput.firstName,
              middleName: formInput.middleName,
              lastName: formInput.lastName,
              paymentTypeId: formInput.paymentType,
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          )
          .then(function (response) {
            if (response.data) {
              setIsLoading(false);
              // GetClaimsForIncompleteManualRemittance(
              //   incompleteManualRemittanceId
              // );
              setClearClaimDetail(true);
              setError({ status: 200, Message: "Claim records Updated." });
              // setPyidForEdit(null);
              // invalidateReactQueryKey(
              //   "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
              // );

              invalidateReactQueryKey(incompleteRemittanceDataItemKey);
            } else {
              setError({
                status: 200,
                Message: "Unable to update the Claim records.",
              });
            }
          })
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
      }
    }
    setClearClaimDetail(false);
  }

  function DeletePaymentMaster(formInput) {
    if (incompleteManualRemittanceId > 0) {
      setIsLoading(true);
      try {
        let accessToken = passedProps.auth.getAccessToken();

        axios
          .post(
            `api/ManualRemittance/DeleteManualRemittanceAll`,
            {
              user: user,
              pMID: formInput.paymentId,
              selectedLocations: formInput.selectedLocations,
              selectedManualPaymentDetailIds: "",
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          )
          .then(function (response) {
            setIsLoading(false);
            if (response.data) {
              setClearClaimDetail(true);
              setClearPaymentMaster(true);
              setIncompleteManualRemittanceId(null);
              setError({
                status: 200,
                Message: "Manual payment master records deleted.",
              });
              clearAllFormsAndGrids();
            } else {
              setError({
                status: 500,
                Message: "Unable to delete the manual payment master.",
              });
            }
            // invalidateReactQueryKey(
            //   "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
            // );
            invalidateReactQueryKey(incompleteRemittanceDataItemKey);
            invalidateReactQueryKey(claimsGridDataQueryKey);
          })
          .catch(onFailure);
      } catch (exception) {
        onFailure(exception);
      }
    } else {
      setClearPaymentMaster(true);
    }
  }

  // function onSuccess(response) {
  //   switch (response.config.url) {
  //     // case "api/ManualRemittance/GetClaimsForIncompleteManualRemittance":
  //     //   setIsLoading(false);
  //     //   if (response.data) {
  //     //     presentGridData(response.data);
  //     //   }
  //     //   setEnableAddClaimEntryButton(true);
  //     //   break;
  //     case "api/ManualRemittance/DeleteManualRemittanceDetail":
  //       if (response.data) {
  //         setError({ status: 200, Message: "Claim records deleted." });
  //       } else {
  //         setError({ status: 500, Message: "Unable to delete the claims." });
  //       }

  //       GetClaimsForIncompleteManualRemittance(incompleteManualRemittanceId);
  //       break;
  //     default:
  //       break;
  //   }
  // }

  function onFailure(error) {
    setIsLoading(false);
    setError(error.response);

    return;
  }

  const MainGridAggregateMoneyFooterCell = (props) => {
    var options = {
      aggregateData: mainGridAggregates,
    };

    return AggregateMoneyFooterCell(props, options);
  };

  function getTotal(field) {
    let displayAggregateValue = 0;
    if (field && mainGridAggregates) {
      if (mainGridAggregates[field]) {
        displayAggregateValue = mainGridAggregates[field].sum;
      }
    }
    return displayAggregateValue;
  }

  function RequestsDataProcessor(responseData) {
    // Check if the response data has any rows - if it does, enable buttons, otherwise disable them
    const hasData = Array.isArray(responseData) && responseData.length > 0;
    setGridHasData(hasData);
    let dataWithCleanedDates = GetDataWithCleanedDates(responseData);
    return dataWithCleanedDates;
  }

  function DeleteSelectedClaimsFromIncompleteManualRemittance() {
    let joinedManualPaymentIds = "";

    if (claimGridSelectedKeys) {
      joinedManualPaymentIds = claimGridSelectedKeys.join(",");
    }

    if (joinedManualPaymentIds !== "" && incompleteManualRemittanceId !== 0) {
      setIsLoading(true);
      try {
        let parameters = {
          user: user,
          pMID: incompleteManualRemittanceId,
          selectedLocations: submittedFormData.selectedLocations,
          selectedManualPaymentDetailIds: joinedManualPaymentIds,
          callback: () => {
            setClaimGridSelectedKeys(null);
            invalidateReactQueryKey(claimsGridDataQueryKey);
            setIsLoading(false);
          },
        };

        console.log(parameters);
        mutateForDeleteSelectedClaims(parameters);
      } catch (exception) {
        onFailure(exception);
        setIsLoading(false);
        setDeleteClaimsIsReady(false);
      }
    }

    setDeleteClaimsIsReady(false);
  }

  if (deleteClaimsIsReady) {
    DeleteSelectedClaimsFromIncompleteManualRemittance();
  }

  return (
    <React.Fragment>
      <div className="feature">
        <LoadingSpinner
          isDataLoading={isLoading || isLoadingIncompleteRemittance}
          controlsName={"ManualRemittance"}
        />
        <canvas
          id="hiddenCanvasForSingleCheckPdf"
          style={{ display: "none" }}
          width={185}
          height={70}
        />
        <ErrorHandler
          error={error}
          onClose={() => {
            setError({});
          }}
        />
        <Accordion defaultExpanded label="Check Information">
          <Row>
            <Col>
              <ManualRemittanceForm
                handleFormSubmit={handleFormSubmit}
                handleEntryOptionsChange={handleEntryOptionsChange}
                paymentId={incompleteManualRemittanceId}
                handleUpdateCheck={HandleUpdateCheckClick}
                handleResetCheck={handleResetCheck}
                clearAll={clearPaymentMaster}
                passedProps={passedProps}
                currentCheckData={currentCheckData}
                onlyUpdateSubmittedFormDataFromChild={
                  onlyUpdateSubmittedFormDataFromChild
                }
              />
            </Col>
          </Row>
        </Accordion>
        <Accordion defaultExpanded label="Claim Entry">
          <Row>
            <Col>
              <ClaimEntry
                handleFormSubmit={HandleClaimEntryFormSubmit}
                claimDetail={retrievedClaimDetail}
                clearAll={clearClaimDetail}
                entryOptionProp={entryOption}
                enableAddClaimEntryButton={hasActiveManualRemittance()}
              />
            </Col>
          </Row>
        </Accordion>{" "}
        <Row className="justify-content-md-end">
          <Col md="auto">
            {/** Reset Claims Button with DisabledItemNotification */}
            <DisabledItemNotification
              isDisabled={() => !hasActiveManualRemittance() || !gridHasData}
              tooltip="No claims have been entered"
            >
              <Button
                variant="primary"
                onClick={handleResetClaimOnClick}
                style={{ width: "100%" }}
              >
                Reset Claims
              </Button>
            </DisabledItemNotification>
          </Col>{" "}
          <Col md="auto">
            {/** Create Remittance Button with DisabledItemNotification */}
            <DisabledItemNotification
              isDisabled={() => !hasActiveManualRemittance() || !gridHasData}
              tooltip="To create a remittance, please enter claim detail"
            >
              <Button
                variant="primary"
                onClick={handleCreateRemittanceOnClick}
                style={{ width: "100%" }}
              >
                Create Remittance
              </Button>
            </DisabledItemNotification>
          </Col>
        </Row>
        <Row>
          <Col className="tight-grid multi-line-filter">
            <SharedMainSelectableClientGrid
              ref={gridRef}
              apiGetEndpoint={
                "api/ManualRemittance/GetClaimsForIncompleteManualRemittance"
              }
              disableCache={true}
              onDataRetrievedProcessor={RequestsDataProcessor}
              apiParameters={clientGridApiParams}
              dataItemKey={"id"}
              aggregateColumnSettings={mainGridMoneyColumnAggregateSettings}
              sendAggregatesParentCallback={sendAggregatesToParent}
              exportFileNamePrefix={"ManualRemittance"}
              selectionColumntitle={"Remove"}
              gridButtons={gridButtons}
              isSelectable={true}
              pageSize={100}
            >
              <GridColumn
                field=""
                title="Action"
                filterable={false}
                sortable={false}
                groupable={false}
                width={DefaultWideColumnWidth()}
                cells={{ data: RemittanceLookupActionCell }}
              />
              <GridColumn
                field="script"
                title="Script"
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"ncpdp"}
                field="ncpdp"
                title="NCPDP"
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"dispensedDate"}
                field="dispensedDate"
                title="Dispensed Date"
                filter="date"
                format="{0:d}"
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"adjustment"}
                field="adjustment"
                title="Promise to Pay"
                format="{0:c}"
                filter="numeric"
                cells={{
                  data: MoneyCell,
                  footerCell: MainGridAggregateMoneyFooterCell,
                }}
                footerCell={MainGridAggregateMoneyFooterCell}
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"paidAmount"}
                field="paidAmount"
                title="Paid Amount"
                format="{0:c}"
                filter="numeric"
                cells={{
                  data: MoneyCell,
                  footerCell: MainGridAggregateMoneyFooterCell,
                }}
                footerCell={MainGridAggregateMoneyFooterCell}
                width={DefaultColumnWidth()}
              />
              <GridColumn
                key={"outStandingAmount"}
                field="outStandingAmount"
                title="Outstanding"
                filter="numeric"
                width={DefaultColumnWidth()}
                cells={{
                  data: MoneyCell,
                  footerCell: MainGridAggregateMoneyFooterCell,
                }}
                footerCell={MainGridAggregateMoneyFooterCell}
              />
              <GridColumn
                key={"transactionFee"}
                field="transactionFee"
                title="Transaction Fee"
                filter="numeric"
                width={DefaultColumnWidth()}
                cells={{
                  data: MoneyCell,
                  footerCell: MainGridAggregateMoneyFooterCell,
                }}
                footerCell={MainGridAggregateMoneyFooterCell}
              />
              {entryOption.includePatientName ? (
                <GridColumn
                  key={"firstName"}
                  field="firstName"
                  title="First Name"
                  width={DefaultColumnWidth()}
                />
              ) : (
                ""
              )}

              {entryOption.includePatientName ? (
                <GridColumn
                  key={"middleName"}
                  field="middleName"
                  title="Middle Name"
                  width={DefaultColumnWidth()}
                />
              ) : (
                ""
              )}

              {entryOption.includePatientName ? (
                <GridColumn
                  key={"lastName"}
                  field="lastName"
                  title="Last Name"
                  width={DefaultColumnWidth()}
                />
              ) : (
                ""
              )}

              {entryOption.includePaymenttype ? (
                <GridColumn
                  key={"paymentType"}
                  field="paymentType"
                  title="Payment Type"
                  width={DefaultColumnWidth()}
                />
              ) : (
                ""
              )}
            </SharedMainSelectableClientGrid>
          </Col>
        </Row>
      </div>

      <Modal
        show={showResetClaimsModal}
        onHide={() => {
          setShowResetClaimsModal(false);
        }}
      >
        <Modal.Header closeButton>
          <h4>Reset Claim for manual remittance</h4>
        </Modal.Header>
        <Modal.Body>
          Clicking 'Ok' will reset claims for this manual remittance using date
          range and selected list of NCPDP's
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleResetClaimsOkModal}>
            Ok
          </Button>
          <Button variant="secondary" onClick={handleResetClaimsCancelModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUnableLocateClaimsModal}
        onHide={() => {
          setShowUnableLocateClaimsModal(false);
        }}
      >
        <Modal.Header closeButton>
          <h4>Claim Warning</h4>
        </Modal.Header>
        <Modal.Body>
          Unable to locate claim. Click 'Ok' to continue loading
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCreateManualClaim}>
            Ok
          </Button>
          <Button variant="secondary" onClick={handleCancelCreateManualClaim}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={createRemittanceConfirmationModal}
        onHide={() => {
          setCreateRemittanceConfirmationModal(false);
        }}
      >
        <Modal.Header closeButton>
          <h4>Post Remittance Advice</h4>
        </Modal.Header>
        <Modal.Body>
          {getTotal("paidAmount") > 0
            ? "Click 'Ok' to post remittance with an adjustment of $" +
            parseFloat(
              parseFloat(submittedFormData.checkAmount) -
              getTotal("paidAmount")
            ).toFixed(2)
            : "Click 'Ok' to post remittance."}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCreateRemittanceOkModal}>
            Ok
          </Button>
          <Button
            variant="secondary"
            onClick={handleCreateRemittanceCancelModal}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={paymentExportModel}
        onHide={() => {
          setPaymentExportModel(false);
        }}
      >
        <Modal.Header closeButton>
          <h4>Print Remittance Advice</h4>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="link" onClick={() => downloadClick("Excel")}>
            Download Excel
          </Button>
          <Button variant="link" onClick={() => downloadClick("PDF")}>
            Download PDF
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setPaymentExportModel(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
